$(() => {
  const submit = event => {
    const form = event.target.form
    form.getAttribute('data-remote') ? Rails.fire(form, 'submit') : form.submit()
  }
  const selector = 'input.autosubmit:visible, select.autosubmit:visible, textarea.autosubmit:visible'
  $(document).on('change', selector, submit)
})
